<template>
  <div class="launch-section">
    <div class="sub-nav-launch">
      <button class="sub-nav-btn" :class="{ active: currentLaunchTab === 'setup' }" @click="switchLaunchTab('setup')">
        设置发送内容
      </button>
      <button class="sub-nav-btn" :class="{ active: currentLaunchTab === 'active' }" @click="switchLaunchTab('active')">
        活跃icebreaker列表
      </button>
    </div>

    <!-- 设置发送内容 -->
    <div v-if="currentLaunchTab === 'setup'" class="setup-content">
      <!-- 邮件设置卡片 -->
      <div class="setup-card" style="margin-bottom: 24px;">
        <div class="card-header">
          <i class="el-icon-message"></i>
          <h3>设置邮件icebreaker</h3>
        </div>
        <div class="info-banner">
          您有活跃的icebreaker，但您可以随时替换它们。
        </div>
        <div class="icebreaker-selector">
          <el-select v-model="mailIcebreaker" placeholder="Start typing to find an icebreaker" filterable
            class="icebreaker-select" @visible-change="(visible) => handleVisibleChange(visible, 'mail')">
            <el-option v-for="item in mailIcebreakers" :key="item.id" :label="item.content" :value="item.id">
              {{ item.content }}
            </el-option>
            <!-- 自定义空状态内容 -->
            <div slot="empty">
              <div v-if="loading.mail" class="initial-loading">
                <div class="loading-spinner">
                  <i class="el-icon-loading"></i>
                  <span>正在加载数据...</span>
                </div>
              </div>
              <div v-else class="no-more">
                <span>无数据</span>
              </div>
            </div>
            <!-- 加载更多 -->
            <div v-if="pagination.mail.loading && mailIcebreakers.length > 0" class="loading-more">
              <i class="el-icon-loading"></i> 加载中...
            </div>
            <div v-else-if="!pagination.mail.hasMore && mailIcebreakers.length > 0" class="no-more">
              没有更多数据了
            </div>
          </el-select>
        </div>
        <div class="card-footer" @click="switchOnIcebreakersFun">
          <button class="launch-btn">
            <i class="el-icon-s-promotion"></i>
            启动
          </button>
        </div>
      </div>
      <!-- 聊天设置 -->
      <div class="setup-card">
        <div class="card-header">
          <i class="el-icon-chat-dot-round"></i>
          <h3>设置聊天icebreaker</h3>
        </div>
        <div class="info-banner">
          您有活跃的icebreaker，但您可以随时替换它们。
        </div>
        <div class="mood-selectors">
          <div class="mood-selector-item">
            <div class="mood-label hot-talks">
              <i class="mood-icon">💋</i>
              热门话题
            </div>
            <el-select v-model="chatIcebreakers.hotTalks" placeholder="开始输入以查找icebreaker" filterable
              class="icebreaker-select" @visible-change="(visible) => handleVisibleChange(visible, 'hot_talks')">
              <el-option v-for="item in hotTalksIcebreakers" :key="item.id" :label="item.content" :value="item.id">
                {{ item.content }}
              </el-option>
              <!-- 自定义空状态内容 -->
              <div slot="empty">
                <div v-if="loading.hot_talks" class="initial-loading">
                  <div class="loading-spinner">
                    <i class="el-icon-loading"></i>
                    <span>正在加载数据...</span>
                  </div>
                </div>
                <div v-else class="no-more">
                  <span>无数据</span>
                </div>
              </div>
              <!-- 加载更多 -->
              <div v-if="pagination.hot_talks.loading && hotTalksIcebreakers.length > 0" class="loading-more">
                <i class="el-icon-loading"></i> 加载中...
              </div>
              <div v-else-if="!pagination.hot_talks.hasMore && hotTalksIcebreakers.length > 0" class="no-more">
                没有更多数据了
              </div>
            </el-select>
          </div>
          <div class="mood-selector-item">
            <div class="mood-label real-love">
              <i class="mood-icon">🕊️</i>
              真挚的爱
            </div>
            <el-select v-model="chatIcebreakers.realLove" placeholder="开始输入以查找icebreaker" filterable
              class="icebreaker-select" @visible-change="(visible) => handleVisibleChange(visible, 'real_love')">
              <el-option v-for="item in realLoveIcebreakers" :key="item.id" :label="item.content" :value="item.id">
                {{ item.content }}
              </el-option>
              <!-- 自定义空状态内容 -->
              <div slot="empty">
                <div v-if="loading.real_love" class="initial-loading">
                  <div class="loading-spinner">
                    <i class="el-icon-loading"></i>
                    <span>正在加载数据...</span>
                  </div>
                </div>
                <div v-else class="no-more">
                  <span>无数据</span>
                </div>
              </div>
              <!-- 加载更多 -->
              <div v-if="pagination.real_love.loading && realLoveIcebreakers.length > 0" class="loading-more">
                <i class="el-icon-loading"></i> 加载中...
              </div>
              <div v-else-if="!pagination.real_love.hasMore && realLoveIcebreakers.length > 0" class="no-more">
                没有更多数据了
              </div>
            </el-select>
          </div>
          <div class="mood-selector-item">
            <div class="mood-label friendship">
              <i class="mood-icon">🤝</i>
              友谊
            </div>
            <el-select v-model="chatIcebreakers.friendship" placeholder="开始输入以查找icebreaker" filterable
              class="icebreaker-select" @visible-change="(visible) => handleVisibleChange(visible, 'friendship')">
              <el-option v-for="item in friendshipIcebreakers" :key="item.id" :label="item.content" :value="item.id">
                {{ item.content }}
              </el-option>
              <!-- 自定义空状态内容 -->
              <div slot="empty">
                <div v-if="loading.friendship" class="initial-loading">
                  <div class="loading-spinner">
                    <i class="el-icon-loading"></i>
                    <span>正在加载数据...</span>
                  </div>
                </div>
                <div v-else class="no-more">
                  <span>无数据</span>
                </div>
              </div>
              <!-- 加载更多 -->
              <div v-if="pagination.friendship.loading && friendshipIcebreakers.length > 0" class="loading-more">
                <i class="el-icon-loading"></i> 加载中...
              </div>
              <div v-else-if="!pagination.friendship.hasMore && friendshipIcebreakers.length > 0" class="no-more">
                没有更多数据了
              </div>
            </el-select>
          </div>
        </div>
        <div class="card-footer" style="margin-top: 10px;" @click="createIcebreakersGroupFun">
          <button class="launch-btn">
            <i class="el-icon-s-promotion"></i>
            启动
          </button>
        </div>
      </div>
    </div>

    <!-- 活跃icebreaker列表 -->
    <div v-if="currentLaunchTab === 'active'" class="active-content">
      <!-- 加载动画 -->
      <div v-if="loading.active" class="loading-container">
        <i class="el-icon-loading"></i>
        <p>正在加载活跃icebreaker列表...</p>
      </div>

      <!-- 数据列表 -->
      <div v-else class="active-list">
        <div class="active-list-header">
          <div class="active-header-col">启动时间</div>
          <div class="active-header-col">类型</div>
          <div class="active-header-col">性别</div>
          <div class="active-header-col">消息</div>
          <div class="active-header-col">操作</div>
        </div>
        <div class="active-list-item" v-for="item in activeIcebreakers" :key="item.id">
          <div class="active-item-col launched-col">{{ formatDate(item.launchedAt) }}</div>
          <div class="active-item-col type-col">
            <i :class="item.type === 'mail' ? 'el-icon-message' : 'el-icon-chat-dot-round'"></i>
            {{ item.type === 'mail' ? '邮件' : '聊天' }}
          </div>
          <div class="active-item-col gender-col">
            <i :class="getGenderIcon(item.gender)" :title="getGenderTooltip(item.gender)"></i>
          </div>
          <div class="active-item-col message-col">
            <div class="active-message-text">{{ item.content || item.message }}</div>
            <!-- 图片附件显示 -->
            <div v-if="item.attachments && item.attachments.length > 0" class="attachment-images">
              <div v-for="(attachment, index) in item.attachments" :key="index" class="attachment-item">
                <div v-if="attachment.type === 'photo'" class="image-attachment">
                  <imagePreview :src="attachment.url" :alt="`附件图片 ${index + 1}`"
                    :previewSrcList="getImageUrls(item.attachments)" :currentIndex="index" class="attachment-image" />
                </div>
              </div>
            </div>
            <div class="active-message-tags" v-if="item.moods && item.moods.length">
              <span class="mood-tag" :class="mood.class" v-for="mood in item.moods" :key="mood.type">
                <i :class="mood.icon"></i>
                {{ mood.label }}
              </span>
            </div>
          </div>
          <div class="active-item-col actions-col">
            <button class="deactivate-btn" @click="deactivateIcebreaker(item.id)">
              × 停用
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIcebreakersListMailToLaunch, getIcebreakersLaunched, getIcebreakersListMessageToLaunch, switchOnIcebreakers, createIcebreakersGroup, stopIcebreakers } from '@/api/talkytimes/icebreakers'
import imagePreview from '@/components/imagePreview.vue'
export default {
  name: 'LaunchIcebreaker',
  components: {
    imagePreview
  },
  props: {
    selectedUser: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      currentLaunchTab: 'setup',
      chatIcebreakers: {
        hotTalks: null,
        realLove: null,
        friendship: null
      },
      mailIcebreaker: null,
      // 为不同类型维护独立的数据源
      mailIcebreakers: [],
      hotTalksIcebreakers: [],
      realLoveIcebreakers: [],
      friendshipIcebreakers: [],
      // 分页状态管理
      pagination: {
        mail: { offset: 0, hasMore: true, loading: false, idLast: null },
        hot_talks: { offset: 0, hasMore: true, loading: false, idLast: null },
        real_love: { offset: 0, hasMore: true, loading: false, idLast: null },
        friendship: { offset: 0, hasMore: true, loading: false, idLast: null }
      },
      // 当前激活的选择器类型
      currentActiveType: 'mail',
      // 活跃icebreaker列表
      activeIcebreakers: [],
      // 加载状态
      loading: {
        mail: false,
        hot_talks: false,
        real_love: false,
        friendship: false,
        active: false
      }
    }
  },
  methods: {
    switchOnIcebreakersFun() {
      console.log(this.mailIcebreaker, '启动')
      // return
      this.$confirm('确定启动吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log('启动')
        // return
        switchOnIcebreakers({ id: this.mailIcebreaker }).then(res => {
          this.$message.success('启动成功')
        }).catch(err => {
          console.error('启动失败:', err)
          this.$message.error('启动失败')
        })
      }).catch(() => {
        // 用户取消启动
        console.log('取消启动')
      })
    },
    createIcebreakersGroupFun() {
      // 启动前需要先停用三个消息类型的icebreakers，停用的3个icebreakers的id从/platform/icebreakers/launched接口获取
      this.$confirm('确定启动吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.stopIcebreakersFun().then(() => {
          // 检查是否有3个有效的icebreakers
          const validIcebreakers = Object.keys(this.chatIcebreakers).filter(key => this.chatIcebreakers[key])
          if (validIcebreakers.length !== 3) {
            this.$message.warning('请选择3个不同类型的icebreakers才能启动')
            return
          }
          console.log('启动')
          const icebreakers = []
          Object.keys(this.chatIcebreakers).forEach(key => {
            if (this.chatIcebreakers[key]) {
              // 将键名映射为正确的mood值
              const moodMapping = {
                'hotTalks': 'hot_talks',
                'realLove': 'real_love',
                'friendship': 'friendship'
              }
              icebreakers.push({
                mood: moodMapping[key],
                idIcebreaker: this.chatIcebreakers[key]
              })
            }
          })
          const requestPayload = {
            type: 'message',
            icebreakers: icebreakers
          }
          createIcebreakersGroup(requestPayload).then(res => {
            this.$message.success('启动成功')
          }).catch(err => {
            console.error('启动失败:', err)
            this.$message.error('启动失败')
          })
        }).catch(err => {
          console.error('停用icebreakers失败:', err)
          this.$message.error('停用icebreakers失败，无法启动新的icebreakers')
        })
      }).catch(() => {
        // 用户取消启动
        console.log('取消启动')
      })
    },
    getIcebreakersLaunchedFun() {
      this.loading.active = true

      // 确保有选中的用户
      if (!this.selectedUser || !this.selectedUser.id) {
        console.error('没有选中用户，无法获取活跃icebreakers')
        this.$message.error('请先选择一个用户')
        this.loading.active = false
        return
      }

      // 传递当前选中用户的ID
      const params = {
        idTrustedUser: this.selectedUser.id
      }

      console.log('获取活跃icebreakers，用户ID:', this.selectedUser.id)

      getIcebreakersLaunched(params).then(res => {
        console.log('获取到的活跃icebreakers数据:', res)
        if (res && Array.isArray(res)) {
          this.activeIcebreakers = res.map(item => ({
            id: item.id,
            launchedAt: new Date(item.dateLastLaunched),
            type: item.type || 'message',
            message: item.content,
            content: item.content,
            gender: item.gender || 'all',
            attachments: item.attachments || [],
            moods: item.mood ? [{
              type: item.mood,
              label: this.getMoodLabel(item.mood),
              class: this.getMoodClass(item.mood),
              icon: this.getMoodIcon(item.mood)
            }] : []
          }))
          console.log('处理后的活跃icebreakers:', this.activeIcebreakers)
        } else {
          this.activeIcebreakers = []
          console.log('没有活跃的icebreakers数据')
        }
      }).catch(err => {
        console.error('获取活跃icebreakers失败:', err)
        this.$message.error('获取活跃icebreakers失败')
        this.activeIcebreakers = []
      }).finally(() => {
        this.loading.active = false
      })
    },
    // 获取心情标签
    getMoodLabel(mood) {
      const moodLabels = {
        'real_love': 'Real love',
        'friendship': 'Friendship',
        'hot_talks': 'Hot talks'
      }
      return moodLabels[mood] || mood
    },
    // 获取心情样式类
    getMoodClass(mood) {
      const moodClasses = {
        'real_love': 'real-love',
        'friendship': 'friendship',
        'hot_talks': 'hot-talks'
      }
      return moodClasses[mood] || ''
    },
    // 获取心情图标
    getMoodIcon(mood) {
      const moodIcons = {
        'real_love': '🕊️',
        'friendship': '🤝',
        'hot_talks': '💋'
      }
      return moodIcons[mood] || ''
    },
    getImageUrls(attachments) {
      if (!attachments || !Array.isArray(attachments)) {
        return []
      }
      return attachments
        .filter(attachment => attachment.type === 'photo' && attachment.url)
        .map(attachment => attachment.url)
    },
    getGenderIcon(gender) {
      const genderIcons = {
        'female': 'el-icon-female',
        'male': 'el-icon-male',
        'all': 'el-icon-user-solid'
      }
      return genderIcons[gender] || 'el-icon-user-solid'
    },
    getGenderTooltip(gender) {
      const genderTooltips = {
        'female': '女性',
        'male': '男性',
        'all': '所有人'
      }
      return genderTooltips[gender] || '所有人'
    },
    switchLaunchTab(tab) {
      this.currentLaunchTab = tab
      if (tab === 'active') {
        this.getIcebreakersLaunchedFun()
      }
    },
    // 停用当前活跃的消息类型icebreakers
    stopIcebreakersFun() {
      return new Promise((resolve, reject) => {
        // 确保有选中的用户
        if (!this.selectedUser || !this.selectedUser.id) {
          console.error('没有选中用户，无法停用icebreakers')
          reject(new Error('请先选择一个用户'))
          return
        }

        // 获取当前活跃的icebreakers，传递用户ID
        const params = {
          idTrustedUser: this.selectedUser.id
        }

        getIcebreakersLaunched(params).then(res => {
          if (res && Array.isArray(res)) {
            // 过滤出消息类型的icebreakers
            const messageIcebreakers = res.filter(item => item.type === 'message')

            if (messageIcebreakers.length === 0) {
              // 没有活跃的消息类型icebreakers，直接resolve
              console.log('没有活跃的消息类型icebreakers需要停用')
              resolve()
              return
            }

            // 停用所有消息类型的icebreakers
            const stopPromises = [stopIcebreakers({ id: res[0].idGroup })]

            Promise.all(stopPromises).then(() => {
              console.log(`成功停用 ${messageIcebreakers.length} 个消息类型icebreakers`)
              resolve()
            }).catch(err => {
              console.error('停用icebreakers失败:', err)
              reject(err)
            })
          } else {
            // 没有活跃的icebreakers，直接resolve
            console.log('没有活跃的icebreakers需要停用')
            resolve()
          }
        }).catch(err => {
          console.error('获取活跃icebreakers失败:', err)
          reject(err)
        })
      })
    },
    deactivateIcebreaker(id) {
      // 这里应该调用API来停用icebreaker
      // 暂时先从前端移除，后续可以添加API调用

      this.$confirm('确定停用吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(id, 'id')
        // return
        stopIcebreakers({ id: id }).then(res => {
          console.log(res, '停用')
          this.activeIcebreakers = this.activeIcebreakers.filter(item => item.id !== id)
          this.$message.success('已停用')
        })
      }).catch(() => {
        // 用户取消停用
        console.log('取消停用')
        this.$message.error('取消停用')
      })
    },
    formatDate(date) {
      return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      }).format(date)
    },
    // 获取邮件icebreakers数据（使用 /platform/icebreakers/list/mail-to-launch 接口）
    getMailIcebreakers() {
      const pagination = this.pagination.mail
      if (pagination.loading || !pagination.hasMore) return

      pagination.loading = true
      this.loading.mail = true

      const params = {
        limit: 20,
        offset: pagination.offset
      }

      // 如果不是第一页，添加idLast字段
      if (pagination.idLast !== null) {
        params.idLast = pagination.idLast
      }

      // 明确使用邮件API
      getIcebreakersListMailToLaunch(params).then(res => {
        if (res && res.items) {
          if (pagination.offset === 0) {
            this.mailIcebreakers = res.items
          } else {
            this.mailIcebreakers = [...this.mailIcebreakers, ...res.items]
          }

          // 判断是否有下一页：如果返回数据少于20条，表示没有下一页
          pagination.hasMore = res.items.length === 20
          pagination.offset += res.items.length

          // 更新idLast为当前数据中最早一条的ID
          if (res.items.length > 0) {
            pagination.idLast = res.items[res.items.length - 1].id
          }
        }
      }).catch(err => {
        console.error('获取邮件icebreakers失败:', err)
        this.$message.error('获取邮件icebreakers失败')
      }).finally(() => {
        pagination.loading = false
        this.loading.mail = false
      })
    },
    // 获取聊天icebreakers数据（热门话题、真挚的爱、友谊都使用 /platform/icebreakers/list/message-to-launch 接口）
    getChatIcebreakers(moodType) {
      console.log('112332321', moodType)
      const pagination = this.pagination[moodType]
      if (pagination.loading || !pagination.hasMore) return

      pagination.loading = true
      this.loading[moodType] = true

      const params = {
        limit: 20,
        offset: pagination.offset
      }

      // 如果不是第一页，添加idLast字段
      if (pagination.idLast !== null) {
        params.idLast = pagination.idLast
      }

      // 直接设置mood参数
      params.mood = moodType
      console.log('112332321', params)
      // 所有聊天类型（热门话题、真挚的爱、友谊）都使用消息API
      getIcebreakersListMessageToLaunch(params).then(res => {
        if (res && res.items) {
          // 根据mood类型存储到对应的数据源
          const dataMap = {
            'hot_talks': 'hotTalksIcebreakers',
            'real_love': 'realLoveIcebreakers',
            'friendship': 'friendshipIcebreakers'
          }

          const dataKey = dataMap[moodType]
          if (dataKey) {
            if (pagination.offset === 0) {
              this[dataKey] = res.items
            } else {
              this[dataKey] = [...this[dataKey], ...res.items]
            }
          }

          // 判断是否有下一页：如果返回数据少于20条，表示没有下一页
          pagination.hasMore = res.items.length === 20
          pagination.offset += res.items.length

          // 更新idLast为当前数据中最早一条的ID
          if (res.items.length > 0) {
            pagination.idLast = res.items[res.items.length - 1].id
          }
        }
      }).catch(err => {
        console.error('获取聊天icebreakers失败:', err)
        this.$message.error('获取聊天icebreakers失败')
      }).finally(() => {
        pagination.loading = false
        this.loading[moodType] = false
      })
    },
    // 重置分页状态
    resetPagination(type) {
      this.pagination[type] = {
        offset: 0,
        hasMore: true,
        loading: false,
        idLast: null
      }
    },
    // 滚动加载更多数据
    handleScroll(event) {
      const target = event.target
      const scrollTop = target.scrollTop
      const scrollHeight = target.scrollHeight
      const clientHeight = target.clientHeight

      // 当滚动到距离底部100px时触发加载
      if (scrollHeight - scrollTop - clientHeight < 100) {
        this.loadMoreData()
      }
    },
    // 加载更多数据
    loadMoreData() {
      switch (this.currentActiveType) {
        case 'mail':
          this.getMailIcebreakers()
          break
        case 'hot_talks':
          this.getChatIcebreakers('hot_talks')
          break
        case 'real_love':
          this.getChatIcebreakers('real_love')
          break
        case 'friendship':
          this.getChatIcebreakers('friendship')
          break
      }
    },
    // 设置当前激活类型并重置分页
    setActiveType(type) {
      this.currentActiveType = type
      this.resetPagination(type)
    },
    // 处理下拉框显示状态变化（简化版，使用事件传值）
    handleVisibleChange(visible, type) {
      if (visible) {
        this.setActiveType(type)

        // 设置加载状态
        this.loading[type] = true

        // 根据类型调用对应的API
        if (type === 'mail') {
          this.getMailIcebreakers()
        } else {
          this.getChatIcebreakers(type)
        }
      }
    },
    // 检查并加载更多数据
    checkAndLoadMore() {
      const pagination = this.pagination[this.currentActiveType]
      const currentData = this.getCurrentData()

      // 如果当前数据少于10条且有更多数据，自动加载
      if (currentData.length < 10 && pagination.hasMore && !pagination.loading) {
        this.loadMoreData()
      }
    },
    // 获取当前类型的数据
    getCurrentData() {
      const dataMap = {
        'mail': 'mailIcebreakers',
        'hot_talks': 'hotTalksIcebreakers',
        'real_love': 'realLoveIcebreakers',
        'friendship': 'friendshipIcebreakers'
      }

      const dataKey = dataMap[this.currentActiveType]
      return dataKey ? this[dataKey] : this.mailIcebreakers
    },
    // 原有的方法保留，但更新为获取邮件类型数据
    getIcebreakersListMailToLaunchFun() {
      this.getMailIcebreakers()
    },
    // 重置所有数据
    resetAllData() {
      // 清空所有数据
      this.mailIcebreakers = []
      this.hotTalksIcebreakers = []
      this.realLoveIcebreakers = []
      this.friendshipIcebreakers = []
      this.activeIcebreakers = [] // 重置活跃的icebreakers数据

      // 重置分页状态
      this.resetPagination('mail')
      this.resetPagination('hot_talks')
      this.resetPagination('real_love')
      this.resetPagination('friendship')

      // 重置加载状态
      this.loading = {
        mail: false,
        hot_talks: false,
        real_love: false,
        friendship: false,
        active: false // 重置活跃icebreakers的加载状态
      }

      // 重置选择状态
      this.mailIcebreaker = null
      this.chatIcebreakers = {
        hotTalks: null,
        realLove: null,
        friendship: null
      }
    }
  },
  watch: {
    selectedUser: {
      handler(newUser, oldUser) {
        // 当用户切换时，清空所有数据并重新加载
        if (newUser && newUser !== oldUser) {
          console.log('LaunchIcebreaker: 用户切换，重新加载数据', newUser)
          this.resetAllData()

          // 如果当前在活跃icebreakers标签页，重新加载数据
          if (this.currentLaunchTab === 'active') {
            this.$nextTick(() => {
              this.getIcebreakersLaunchedFun()
            })
          }
        }
      },
      immediate: true
    }
  },
  mounted() {
    // 组件挂载时不自动加载数据，等待用户主动操作
  }
}
</script>

<style scoped lang="scss">
/* 组件根元素样式 */
.launch-section {
  background: white;
  border-radius: 0 0 8px 8px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  flex-direction: column;

  /* 确保Element UI样式能够正确应用 */
  :deep(.el-select-dropdown__item) {
    white-space: pre-wrap !important;
    word-wrap: break-word !important;
    word-break: break-all !important;
    line-height: 1.6 !important;
    padding: 15px 20px !important;
    min-height: auto !important;
    height: auto !important;
    // max-width: none !important;
    overflow: visible !important;
    text-overflow: unset !important;
    display: block !important;
    width: 80vw !important;
  }

  :deep(.el-select-dropdown__item span) {
    white-space: pre-wrap !important;
    word-wrap: break-word !important;
    word-break: break-all !important;
    line-height: 1.6 !important;
    display: block !important;
    max-width: none !important;
    overflow: visible !important;
    text-overflow: unset !important;
    padding: 0 !important;
    margin: 0 !important;
  }
}

.sub-nav-launch {
  display: flex;
  gap: 32px;
  padding: 20px 24px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.sub-nav-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #64748b;
  padding: 8px 0;
  position: relative;
}

.sub-nav-btn.active {
  color: #3730a3;
  font-weight: 600;
}

.sub-nav-btn.active::after {
  content: '';
  position: absolute;
  bottom: -20px;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(135deg, #3730a3 0%, #581c87 100%);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(55, 48, 163, 0.4);
}

.setup-content {
  padding: 32px;
}

.setup-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  border: 1px solid #f1f5f9;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.card-header i {
  font-size: 20px;
  color: #3730a3;
}

.card-header h3 {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.info-banner {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  border: 1px solid #3b82f6;
  color: #1e40af;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 24px;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
}

.mood-selectors {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.mood-selector-item {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.mood-selector-item .icebreaker-select {
  width: 80vw;
  flex: 1;
  max-width: 80vw;
  box-sizing: border-box;
}

.mood-label {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 20px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  min-width: 120px;
  flex-shrink: 0;
}

.mood-label.hot-talks {
  background: #ec4899;
}

.mood-label.real-love {
  background: linear-gradient(135deg, #3730a3 0%, #581c87 100%);
  box-shadow: 0 2px 8px rgba(55, 48, 163, 0.4);
}

.mood-label.friendship {
  background: #10b981;
}

.icebreaker-selector {
  margin-bottom: 24px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.icebreaker-select {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.card-footer {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.launch-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #3730a3 0%, #581c87 100%);
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(55, 48, 163, 0.5);
  width: auto;
  min-width: 120px;
  box-sizing: border-box;
}

.launch-btn:hover {
  box-shadow: 0 6px 20px rgba(55, 48, 163, 0.6);
}

/* 活跃列表样式 */
.active-content {
  padding: 32px;
}

.active-list {
  background: white;
  border-radius: 8px;
  overflow: hidden;
}

.active-list-header {
  display: grid;
  grid-template-columns: 120px 80px 80px minmax(400px, 1fr) 120px;
  gap: 16px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 2px solid #e2e8f0;
  font-weight: 700;
  font-size: 14px;
  color: #1f2937;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.active-list-item {
  display: grid;
  grid-template-columns: 120px 80px 80px minmax(400px, 1fr) 120px;
  gap: 16px;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
  align-items: flex-start;
}

.active-list-item:hover {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.active-item-col {
  font-size: 14px;
  color: #1f2937;
  font-weight: 600;
}

.active-item-col.message-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  min-height: 80px;
}

.active-header-col {
  font-size: 14px;
  color: #1f2937;
  font-weight: 700;
}

.active-message-text {
  line-height: 1.5;
  font-weight: 500;
  font-size: 14px;
  word-wrap: break-word;
  white-space: pre-wrap;
  margin-bottom: 8px;
}

.attachment-images {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.attachment-item {
  flex-shrink: 0;
}

.image-attachment {
  position: relative;
}

.attachment-image {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 8px;
  border: 2px solid #e2e8f0;
  cursor: pointer;
  overflow: hidden;
}

.attachment-image:hover {
  border-color: #3730a3;
}

.active-message-tags {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 6px;
}

.mood-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  color: white;
  background: #6b7280;
}

.mood-tag.hot-talks {
  background: #ec4899;
}

.mood-tag.real-love {
  background: #3730a3;
}

.mood-tag.friendship {
  background: #10b981;
}

.deactivate-btn {
  background: none;
  border: 1px solid #ef4444;
  color: #ef4444;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
}

.deactivate-btn:hover {
  background: #ef4444;
  color: white;
}

/* 响应式设计 */
@media (max-width: 768px) {

  .active-list-header,
  .active-list-item {
    grid-template-columns: 100px 60px 60px 1fr 80px;
    gap: 12px;
    padding: 12px 16px;
  }

  .active-message-text {
    font-size: 13px;
  }

  .deactivate-btn {
    padding: 4px 8px;
    font-size: 11px;
  }

  .attachment-image {
    width: 50px;
    height: 50px;
  }

  .attachment-images {
    gap: 6px;
  }



  .icebreaker-select :deep(.el-input__inner) {
    font-size: 14px !important;
    padding: 6px 12px !important;
  }

  .icebreaker-select :deep(.el-select-dropdown__item) {
    padding: 10px 15px !important;
    font-size: 14px !important;
  }
}

/* 滚动加载相关样式 */
.loading-more {
  text-align: center;
  padding: 12px;
  color: #909399;
  font-size: 14px;
  background: #f5f7fa;
  border-top: 1px solid #e4e7ed;
}

.loading-more i {
  margin-right: 8px;
}

.no-more {
  text-align: center;
  padding: 12px;
  color: #c0c4cc;
  font-size: 14px;
  background: #f5f7fa;
  border-top: 1px solid #e4e7ed;
}

/* 选择器选项文本换行样式 */
.icebreaker-select {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

/* 确保下拉框与输入框宽度一致 */
.icebreaker-select :deep(.el-select-dropdown) {
  width: 80vw !important;
  position: absolute !important;
  z-index: 2000 !important;
  left: 0 !important;
  right: 0 !important;
  margin: 0 !important;
  box-sizing: border-box !important;
}

/* 使用更具体的选择器来确保样式生效 */
.icebreaker-select :deep(.el-select-dropdown__item) {
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
  word-break: break-all !important;
  line-height: 1.6 !important;
  padding: 15px 20px !important;
  min-height: auto !important;
  height: auto !important;
  width: 80vw !important;
  overflow: visible !important;
  text-overflow: unset !important;
  display: block !important;
  box-sizing: border-box !important;
}

.icebreaker-select :deep(.el-select-dropdown__item span) {
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
  word-break: break-all !important;
  line-height: 1.6 !important;
  display: block !important;
  max-width: none !important;
  overflow: visible !important;
  text-overflow: unset !important;
  padding: 0 !important;
  margin: 0 !important;
}

/* 选择器输入框文本换行 */
.icebreaker-select :deep(.el-input__inner) {
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  line-height: 1.5 !important;
  height: auto !important;
  min-height: 40px !important;
  padding: 8px 15px !important;
  overflow-wrap: break-word !important;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
}

/* 下拉框宽度和最大高度 */
.icebreaker-select :deep(.el-select-dropdown__list) {
  max-height: 300px !important;
  overflow-y: auto !important;
  width: 100% !important;
  box-sizing: border-box !important;
}

/* 选中项的显示样式 */
.icebreaker-select :deep(.el-select__tags) {
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  line-height: 1.5 !important;
  overflow-wrap: break-word !important;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
}

.icebreaker-select :deep(.el-select__tags-text) {
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  line-height: 1.5 !important;
  max-width: 100% !important;
  overflow-wrap: break-word !important;
  width: 100% !important;
  box-sizing: border-box !important;
}

/* 确保选中文本能够换行显示 */
.icebreaker-select :deep(.el-select__input) {
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  line-height: 1.5 !important;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
}

.icebreaker-select :deep(.el-select__input input) {
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  line-height: 1.5 !important;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
}

/* 全局覆盖Element UI的默认样式 */
:deep(.el-select-dropdown__item) {
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  line-height: 1.5 !important;
  padding: 12px 20px !important;
  min-height: auto !important;
  height: auto !important;
  max-width: 100% !important;
  overflow: hidden !important;
}

:deep(.el-select-dropdown__item span) {
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  line-height: 1.5 !important;
  display: block !important;
  max-width: 100% !important;
  overflow-wrap: break-word !important;
}



/* 强制覆盖Element UI的默认文本样式 */
:deep(.el-select-dropdown__item) {
  text-overflow: unset !important;
  overflow: visible !important;
}

:deep(.el-select-dropdown__item span) {
  text-overflow: unset !important;
  overflow: visible !important;
  white-space: pre-wrap !important;
}




/* 全局样式覆盖 - 使用更高优先级的选择器 */
.el-select-dropdown__item {
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
  word-break: break-all !important;
  line-height: 1.6 !important;
  padding: 15px 20px !important;
  min-height: auto !important;
  height: auto !important;
  max-width: 80vw !important;
  overflow: visible !important;
  text-overflow: unset !important;
  display: block !important;
}

.el-select-dropdown__item span {
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
  word-break: break-all !important;
  line-height: 1.6 !important;
  display: block !important;
  max-width: 80vw !important;
  overflow: visible !important;
  text-overflow: unset !important;
  padding: 0 !important;
  margin: 0 !important;
}

.el-select-dropdown {
  width: 80vw !important;
  position: absolute !important;
  z-index: 2000 !important;
  left: 0 !important;
  right: 0 !important;
  margin: 0 !important;
  box-sizing: border-box !important;
}

.el-select-dropdown__list {
  max-height: 300px !important;
  overflow-y: auto !important;
  padding: 0 !important;
  width: 80vw !important;
  box-sizing: border-box !important;
}

/* 全局滚动条样式 */
.el-scrollbar {
  width: 80vw !important;
}

.el-scrollbar__wrap {
  width: 80vw !important;
}

/* 加载动画样式 */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  color: #666;
}

.loading-container i {
  font-size: 32px;
  color: #409EFF;
  margin-bottom: 16px;
}

.loading-container p {
  font-size: 16px;
  margin: 0;
  color: #666;
}

/* 初始加载动画样式 */
.initial-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  min-height: 120px;
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.loading-spinner i {
  font-size: 24px;
  color: #409EFF;
}

.loading-spinner span {
  font-size: 14px;
  color: #666;
}

/* 旋转动画 */

/* 下拉框中的加载更多样式 */
.loading-more {
  text-align: center;
  padding: 12px 20px;
  color: #666;
  font-size: 14px;
}

.loading-more i {
  margin-right: 8px;
}

.no-more {
  text-align: center;
  padding: 12px 20px;
  color: #999;
  font-size: 14px;
}

.el-scrollbar__view {
  width: 80vw !important;
}

/* 用户信息横幅样式 */
.user-info-banner {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 1px solid rgba(55, 48, 163, 0.2);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(55, 48, 163, 0.1);
}

.user-info-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.user-info-content .user-avatar {
  position: relative;
  flex-shrink: 0;
}

.user-info-content .avatar-img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.user-info-content .online-indicator {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #d1d5db;
  border: 2px solid white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.user-info-content .online-indicator.online {
  background: #10b981;
  box-shadow: 0 1px 4px rgba(16, 185, 129, 0.4);
}

.user-info-content .user-details {
  flex: 1;
  min-width: 0;
}

.user-info-content .user-name {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-info-content .user-id {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
}

.user-info-content .user-status {
  flex-shrink: 0;
}

.user-info-content .vip-icon {
  color: #fbbf24;
  font-size: 18px;
  text-shadow: 0 1px 2px rgba(251, 191, 36, 0.3);
}
</style>